import { render } from "./OrderReferralPartner.vue?vue&type=template&id=7b1a4583"
import script from "./OrderReferralPartner.vue?vue&type=script&lang=js"
export * from "./OrderReferralPartner.vue?vue&type=script&lang=js"
script.render = render

export default script